<template>
  <div
    class="is-border vadTask"
    :class="{'is-grey has-text-grey': !isNew, 'has-background-white': isNew}">
    <div class="vadTask-hover"></div>
    <div class="is-padding-left is-padding-right is-padding-top-small is-padding-bottom-small">
      <div class="columns">
        <div class="column is-narrow">
          <avatar
            :use-picto-custom="'fal fa-comment-alt-lines'"
            :force-picto="true"
            :is-avatar="false"
            :item="{}"
            class="has-background-notification is-medium has-text-white is-margin-top-xsmall">
          </avatar>
        </div>
        <div class="column">
          <p class="is-size-7 has-text-weight-light has-text-grey is-margin-bottom-xxsmall">
            <span v-if="isToday">Aujourd’hui à {{ ticket.created_on | dtFormat('HH[h]mm') }}</span>
            <span v-else>{{ ticket.created_on | prettyDatetime }}</span>
          </p>
          <p class="is-size-4">
            <router-link :to="{name: 'TicketVue', params: {id: ticketPk}}">
              <strong>Ticket —
                {{ ticket.title }}
              </strong>
            </router-link>
          </p>
          <div class="columns is-multiline">
            <div class="column is-narrow">
              <span class="has-text-grey is-size-6">Utilisateur :</span><br>
              <router-link
                :to="{name: 'UserVue', params: {id: ticket.user.pk}}"
                class="is-size-6">
                <span class="is-hover-underline">{{ ticket.user.first_name }} {{ ticket.user.last_name }}</span>
              </router-link>
            </div>
            <div
              v-if="ticket.user.account && ticket.user.account.pk !== currentUser.account.pk"
              class="column is-narrow">
              <span class="has-text-grey is-size-6">Société :</span><br>
              <router-link
                :to="{name: 'CompanyVue', params: {id: ticket.user.account.pk}}"
                class="is-size-6">
                <span class="is-hover-underline">{{ ticket.user.account.name }}</span>
              </router-link>
            </div>
            <div class="column is-12 is-narrow">
              <span class="has-text-grey">Message :</span><br><span>{{ ticket.message | truncate(300) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
      mode="out-in">
      <div
        v-if="isNew"
        key="buttons"
        class="veryFastAnimation is-paddingless-top is-paddingless-bottom is-border-top is-border--dashed vadTask-footer">
        <router-link
          :to="{name: 'TicketVue', params: { id: ticketPk }}"
          class="button is-white is-small is-size-7">
          <span class="icon is-small"><i class="far fa-external-link-alt"></i></span>
          <span>Consulter</span>
        </router-link>
        <!-- <button
          v-if="!isClosed"
          @click="markAsClosed"
          class="button is-white is-small is-size-7"
          :disabled="cardLoading">
          <span class="icon is-small"><i class="fas fa-times"></i></span>
          <span>Clore le ticket</span>
        </button> -->
        <button
          v-if="isNew"
          @click="marskAsHandle"
          class="button is-white is-small is-size-7"
          :disabled="cardLoading">
          <span class="icon is-small"><i class="fas fa-check"></i></span>
          <span>Prévenir le correspondant de la prise en charge de sa demande</span>
        </button>
      </div>
      <div
        v-else-if="!isNew && lastEvent"
        key="noButtons"
        class="veryFastAnimation is-padding-top-xsmall is-padding-bottom-xsmall is-border-top vadTask-footer has-background-light--darken1 is-border-top is-border--dashed ">
        <div class="">
          <span class="has-text-grey is-size-6">{{ lastEvent.created_on.seconds | dtUnixFormat('DD/MM HH:mm') }} : {{ lastEvent.title }}</span>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { firestore as db } from '../../firebaseApp'
import { mapState } from 'vuex'
import { mapGetters } from 'vuex/dist/vuex.esm.browser'
import moment from 'moment'

export default {
  name: 'TicketCard',
  props: {
    ticket: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      logs: [],
      cardLoading: false
    }
  },
  computed: {
    ...mapState(['currentUser']),
    ...mapGetters(['currentUserPk']),
    /**
      * return moment() created_on
      * @return {string}
      */
    date () {
      return moment(this.ticket.created_on)
    },
    /**
      * is today
      * @return {boolean}
      */
    isToday () {
      return this.date.isSame(moment(), 'day')
    },
    /**
      * ticket pk
      * @return {string}
      */
    ticketPk () {
      return this.ticket.pk
    },
    /**
      * ticket status
      * @return {string}
      */
    status () {
      return this.ticket.status
    },
    /**
      * status is in_progress
      * @return {boolean}
      */
    isInProgress () {
      return this.status === 'in_progress'
    },
    /**
      * status is new
      * @return {boolean}
      */
    isNew () {
      return this.status === 'new'
    },
    /**
      * status is closed
      * @return {boolean}
      */
    isClosed () {
      return this.status === 'closed'
    },
    /**
      * first logs child
      * @return {object}
      */
    lastEvent () {
      if (this.logs.length > 0) {
        return this.logs[0]
      }
      return null
    }
  },
  created () {
    this.$bind('logs', db.collection('ticket').doc(this.ticket.pk).collection('events').orderBy('created_on', 'desc'))
  },
  methods: {
    /**
      * emit updateTicket with pk and status
      * @param {string} - status
      */
    updateTicket (status) {
      this.$emit('updateTicket', this.ticketPk, status)
    },
    /**
      * call updateTicket with status closed
      */
    markAsClosed () {
      this.updateTicket('closed')
    },
    /**
      * call updateTicket with status in_progress
      */
    marskAsHandle () {
      this.updateTicket('in_progress')
    }
  }
}
</script>

<style scoped>

</style>
